import { GET_INSIGHTS_URL_SUCCESS, GET_MINSIGHT_CLAIM_REPORT_SUCCESS, GET_MINSIGHT_CLAIM_REPORT_FAIL } from "../actions";

const initialState = {
   mhcInsightsUrl: null,
   mhcInsightsClaimReport: null
};
export default function (state = initialState, action) {
   switch (action.type) {
      case GET_INSIGHTS_URL_SUCCESS:
         return Object.assign({}, state, { mhcInsightsUrl: action.payload.data.redirect_url });
      case GET_MINSIGHT_CLAIM_REPORT_SUCCESS:
         return Object.assign({}, state, { mhcInsightsClaimReport: action.payload.data });
      case GET_MINSIGHT_CLAIM_REPORT_FAIL:
         return Object.assign({}, state, { mhcInsightsClaimReport: null });
      default:
         return state;
   }
}
